export default "__VITE_ASSET__YBnC5GAR__"